import React, { useState } from "react";
import { Badge, Card, Button, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const features = [
    "Guaranteed spot — always available",
    "Unlimited entry & exit (24/7 access)",
    "Members-only perks & discounts",
    "No daily booking required",
    "Best value for frequent drivers",
];

function ExtendParking({
    isMonthlySubscription,
    setIsMonthlySubscription,
    setSelectedBookingType,
    extensionDuration,
    setExtensionDuration,
    subscriptionAmount,
}) {
    const [active, setActive] = useState(true);

    const handleExtendSelect = (label) => {
        setIsMonthlySubscription(false);
        if (label === "Add 1 Day") { setSelectedBookingType("DAY"); setExtensionDuration("1_DAY"); }
        else if (label === "Add 3 days") { setSelectedBookingType("DAY"); setExtensionDuration("3_DAY"); }
        else if (label === "Add Week") { setSelectedBookingType("WEEKLY"); setExtensionDuration("WEEK"); }
    };

    return (
        <Card
            className="border border-dark mt-3 w-100 rounded-3"
        >
            <Card.Body className="p-0 mb-3">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <Badge pill className="p-2"> 🔥 Best Value </Badge>
                    <Form.Check
                        type="switch"
                        checked={isMonthlySubscription}
                        onChange={() => {
                            setIsMonthlySubscription((v) => !v);
                            setSelectedBookingType("MONTHLY_SUBSCRIPTION"); 
                        }}
                        className="m-0 fs-3"
                    />
                </div>

                {/* Title */}
                <Card.Title className="fw-bold fs-4 mb-3">
                    Monthly Subscription
                </Card.Title>

                {/* Features + Price */}
                <div className="d-flex gap-3 align-items-start">
                    <ul className="list-unstyled flex-grow-1 mb-0 small">
                        {features.map((f) => (
                            <li key={f} className="mb-1">
                                <span style={{ color: "#00c8ff" }}>✓ </span>{f}
                            </li>
                        ))}
                    </ul>

                    <Badge className="fs-4 fw-bold px-3 py-2 flex-shrink-0 rounded-pill" >
                        ${subscriptionAmount || '0'}<small className="mb-3" style={{ fontSize: 13 }}> /month</small>
                    </Badge>
                </div>
            </Card.Body>

            {/* Action Buttons */}
            <Card.Footer
                className="p-0 d-flex gap-5 justify-content-around border-top pt-3  border-secondary"
                style={{ gridTemplateColumns: "repeat(3,1fr)" }}
            >
                {["Add 1 Day", "Add 3 days", "Add Week"].map((label, i) => (
                    <Button
                        key={label}
                        variant="dark"
                        className="rounded-4 py-2 w-100 text-white fw-semibold"
                        onClick={() => handleExtendSelect(label)}
                    >
                        {label}
                    </Button>
                ))}
            </Card.Footer>
        </Card>
    );
}

export default React.memo(ExtendParking);